import React from 'react';
import Dashboard from './Dashboard';
import AuthenticationForm from './AuthenticationForm';

const Authentication = () => (
  <div className="wrapper">
    <Dashboard />
    <AuthenticationForm />
  </div>
);

export default Authentication;
